<template>
  <BliModal
    type="drawer"
    :active="isModalVisible"
    position="right"
    width="small"
    @blur="$emit('closeModal')"
    @close="$emit('closeModal')"
  >
    <BliModalHeader @close="$emit('closeModal')">
      <template #title>
        {{ $t('notification.title') }}
      </template>
      <template #item-trailing>
        <BliButton
          class="open-icon"
          prominence="tertiary"
          size="small"
          @click="navigateToNotificationPage"
        >
          {{ $t('notification.viewNotificationPage') }}
        </BliButton>
      </template>
    </BliModalHeader>
    <div
      class="body-container"
    >
      <BliModalBody
        has-no-padding
        class="body-wrapper"
      >
        <NotificationList />
      </BliModalBody>
    </div>
  </BliModal>
</template>
<script src="./index.js" />
<style scoped lang="scss">
    html:not([dark]) {
      @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
    }
    html[dark] {
      @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
    }
    @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
 .body-container {
    height: 100%;
    overflow: hidden;
    ::v-deep .body-wrapper {
        height: 100%;
        overflow: hidden;
        ::v-deep .blu-modal__body-content{
            height: 100%;
            overflow: hidden;
            }
        }
    }

.open-icon {
    cursor: pointer;
}
</style>
